import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout, getParentLayout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'

const { t } = useI18n()

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/datacenter/datalist',
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'Redirect',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'RedirectChildren',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    //component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/sellerApplication',
    component: () => import('@/views/SellerApplication/SellerApplication.vue'),
    name: 'SellerApplication',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  },
  {
    path: '/data',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/datacenter',
    component: Layout,
    redirect: '/level/menu1/menu1-1/menu1-1-1',
    name: 'DataCenter',
    meta: {
      title: t('router.dataCenter'),
      icon: 'svg-icon:database',
      alwaysShow: true
    },

    children: [
      {
        path: 'datalist',
        name: 'DataList',
        component: () => import('@/views/DataCenter/DataStatistic.vue'),
        meta: {
          title: t('router.dataCenter1'),
          hidden: false
        }
      }
    ]
  },
  {
    path: '/orderCenter',
    component: Layout,
    name: 'OrderCenter',
    meta: {
      title: t('router.orderCenter'),
      icon: 'svg-icon:order-center',
      alwaysShow: true
    },

    children: [
      {
        path: 'orderList',
        name: 'OrderList',
        component: () => import('@/views/OrderCenter/OrderList.vue'),
        meta: {
          title: t('router.orderList'),
          hidden: false
        }
      },
      {
        path: 'orderList/:id?',
        name: 'OrderList',
        component: () => import('@/views/OrderCenter/OrderList.vue'),
        meta: {
          title: t('router.orderList'),
          hidden: true
        }
      },
      {
        path: 'orderDetails/:id',
        name: 'OrderDetails',
        component: () => import('@/views/OrderCenter/components/OrderDetails.vue'),
        meta: {
          title: t('router.orderDetails'),
          hidden: true
        }
      }
    ]
  },
  {
    path: '/productCenter',
    component: Layout,
    name: 'ProductCenter',
    meta: {
      title: t('router.goodsCenter'),
      icon: 'svg-icon:goods-center',
      hidden: false
    },

    children: [
      {
        path: 'productList',
        name: 'ProductList',
        component: () => import('@/views/ProductCenter/ProductList/ProductList.vue'),
        meta: {
          title: t('router.goodsList'),
          hidden: false
        }
      },
      {
        path: 'addProduct',
        name: 'AddProduct',
        component: () => import('@/views/ProductCenter/AddProduct/AddProduct.vue'),
        meta: {
          title: t('router.addProduct'),
          hidden: false
        }
      },
      {
        path: 'editProduct/:id',
        name: 'EditProduct',
        component: () => import('@/views/ProductCenter/AddProduct/AddProduct.vue'),
        meta: {
          title: t('router.editProduct'),
          hidden: true,
          keepAlive: true
        }
      },
      {
        path: 'viewProduct/:id',
        name: 'ViewProduct',
        component: () => import('@/views/ProductCenter/AddProduct/AddProduct.vue'),
        meta: {
          title: t('router.viewProduct'),
          hidden: true
        }
      },
      {
        path: 'onlineTime',
        name: 'OnlineTime',
        component: () => import('@/views/ProductCenter/OnlineTime/OnlineTime.vue'),
        meta: {
          title: t('router.onlineTime'),
          hidden: false
        }
      }
    ]
  },
  {
    path: '/userComments',
    component: Layout,
    name: 'UserComments',
    meta: {
      title: t('router.userComments'),
      icon: 'svg-icon:order-rejected',
      alwaysShow: true
    },

    children: [
      {
        path: 'userCommentsTable',
        name: 'UserCommentsTable',
        component: () => import('@/views/UserComment/CommentList.vue'),
        meta: {
          title: t('router.userCommentsTable')
        }
      },
      {
        path: 'userCommentsTable/:id?',
        name: 'UserCommentsTable',
        component: () => import('@/views/UserComment/CommentList.vue'),
        meta: {
          title: t('router.userCommentsTable'),
          hidden: true
        }
      }
    ]
  },
  {
    path: '/wallet',
    component: Layout,
    name: 'Wallet',
    meta: {
      title: t('router.wallet'),
      icon: 'svg-icon:wallet',
      alwaysShow: true
    },

    children: [
      {
        path: 'walletCenter',
        name: 'WalletCenter',
        component: () => import('@/views/Wallet/WalletCenter.vue'),
        meta: {
          title: t('router.walletCenter')
        }
      },
      {
        path: 'payoutOptions',
        name: 'PayoutOptions',
        component: () => import('@/views/Wallet/WithdrawalMethods.vue'),
        meta: {
          title: t('router.payoutOptions')
        }
      }
    ]
  },
  {
    path: '/messageCenter',
    component: Layout,
    name: 'MessageCenter',
    meta: {
      title: t('router.messageCenter'),
      icon: 'svg-icon:message-center',
      alwaysShow: true
    },
    children: [
      {
        path: 'notification',
        name: 'Notification',
        component: () => import('@/views/MessageCenter/MessageNotification.vue'),
        meta: {
          title: t('router.notification')
        }
      }
    ]
  },
  {
    path: '/accountSecurity',
    component: Layout,
    name: 'AccountSecurity',
    meta: {
      title: t('router.accountSecurity'),
      icon: 'svg-icon:account-security',
      alwaysShow: true
    },
    children: [
      {
        path: 'account',
        name: 'Account',
        component: () => import('@/views/AccountSecurity/Account.vue'),
        meta: {
          title: t('router.account')
        }
      },
      {
        path: 'security',
        name: 'Security',
        component: () => import('@/views/AccountSecurity/Security.vue'),
        meta: {
          title: t('router.security')
        }
      },
      {
        path: 'authentication',
        name: 'Authentication',
        component: () => import('@/views/AccountSecurity/Authentication.vue'),
        meta: {
          title: t('router.authentication')
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  const resetWhiteNameList = ['Redirect', 'Login', 'NoFind', 'Root']
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
